export const GET_SYSTEMS = 'store/systems/GET_SYSTEMS'
export const SET_SORT_PARAMS_SYSTEMS = 'store/systems/SET_SORT_PARAMS_SYSTEMS'
export const SET_SEARCH_PARAMS_SYSTEMS = 'store/systems/SET_SEARCH_PARAMS_SYSTEMS'
export const SET_PAGINATION_PARAMS = 'store/systems/SET_PAGINATION_PARAMS'



// WEBPACK FOOTER //
// ./src/actionTypes/Systems/Systems.js